function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("circle", {
  cx: 19,
  cy: 19,
  r: 19,
  fill: "#fff4e5"
});

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(11 11)"
}, React.createElement("path", {
  d: "M8,0a8,8,0,1,0,8,8A8.024,8.024,0,0,0,8,0ZM8,12a.945.945,0,0,1-1-1,.945.945,0,0,1,1-1,.945.945,0,0,1,1,1A.945.945,0,0,1,8,12ZM9,9H7V4H9Z",
  fill: "#ff9d00"
}));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "storage/static/media/low-in-stock.baf38aff.svg";
export { SvgComponent as ReactComponent };